<template>
  <div>
    <section class="content cleafix">
      <form class="company-info">
        <h1 class="form-head">
          关联三方账户
        </h1>
        <div class="form-body">
          <div class="input-item n-m-b">
            <div class="logo">
              <img :alt="user.nickname" :src="user.avatar">
            </div>
          </div>
          <div class="input-item show-info text-center">
            <span class="email">{{user.screen_name}}</span>
          </div>
          <div class="input-item">
            <input type="text" class="input" name="username" placeholder="关联账户手机号或者邮箱" required="required" v-model.trim="username" autocomplete="off" @blur="checkUsername()">
            <span class="input-tips">{{error.username}}</span>
          </div>
          <div class="input-item clearfix">
            <div class="col-xs-12 clearfix">
              <div class="row clearfix">
                <div class="col-sm-7 n-p-l">
                  <input type="text" class="input" v-model.trim="verifyCode" placeholder="验证码：6位" @blur="validateCode()">
                </div>
                <div class="col-sm-5 n-p-r n-p-l">
                  <button type="button" class="btn btn-md btn-primary col-xs-12" :disabled="reset.disabled" @click="sendVerifyCode()">{{reset.text}}</button>
                </div>
              </div>
              <div class="row">
                <span class="input-tips">{{error.code}}</span>
              </div>
            </div>
          </div>
          <div class="input-item">
            <input type="button" class="btn btn-primary btn-md col-xs-12" value="关联账户" @click="registerFunc()">
          </div>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Auth from "../../resource/auth";
export default {
  data: function() {
    return {
      type: 1,
      category: 1,
      username: "",
      verifyCode: "",
      error: {
        username: "",
        code: "",
        nickname: ""
      },
      validate: [0, 0],
      reset: {
        text: "发送验证码",
        disabled: false,
        timer: null,
        seconds: 60
      },
      register: {
        disabled: true,
        validate: [0, 0]
      }
    };
  },
  computed: {
    validateFlag: function() {
      const that = this;
      let tmp = that.validate.join("");
      return tmp;
    },
    ...mapGetters({
      user: "loginUser"
    })
  },
  created: function() {
    const that = this;
    document.title = `关联三方账户|${that.global.name}`;
    that.$store.dispatch("getSession");
  },
  methods: {
    checkUsername: function() {
      const that = this;
      if (that.global.regex.email.test(that.username)) {
        that.error.username = "";
        that.register.validate[1] = 1;
        that.reset.disabled = false;
        that.register.disabled = that.register.validate.join("") !== "11";
        that.type = 2;
      } else if (that.global.regex.phone.test(that.username)) {
        that.error.username = "";
        that.register.validate[1] = 1;
        that.reset.disabled = false;
        that.register.disabled = that.register.validate.join("") !== "11";
        that.type = 1;
      } else {
        that.register.validate[1] = 0;
        that.error.username = "请输入正确的手机号、邮箱";
        that.reset.disabled = true;
      }
    },
    sendVerifyCode: function() {
      const that = this;
      that.reset.disabled = true; // 禁用按钮
      Auth.sendVerifyCode({ username: that.username }).then(res => {
        if (res.status === 200) {
          let data = res.body;
          if (data.code === 0) {
            // 校验成功
            that.reset.seconds = 60;
            that.reset.text = `${that.reset.seconds}s后，重发`;
            that.reset.timer = setInterval(() => {
              // 倒计时
              if (that.reset.seconds === 0) {
                that.reset.disabled = false;
                that.reset.text = `重发验证码`;
                clearInterval(that.reset.timer);
                that.reset.timer = null;
              } else {
                that.reset.seconds--;
                that.reset.text = `${that.reset.seconds} s后，重发`;
              }
            }, 1000);
          } else {
            that.reset.disabled = false;
            alert(data.msg);
          }
        } else {
          alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
        }
      });
    },
    validateCode: function() {
      const that = this;
      if (that.verifyCode == "") {
        that.register.disabled = true;
        that.register.validate[0] = 0;
        that.error.code = "请输入验证码";
        return;
      }
      if (that.global.regex.verify_code.test(that.verifyCode)) {
        that.error.code = "";
        that.register.validate[0] = 1;
        that.register.disabled = that.register.validate.join("") !== "11";
      } else {
        that.error.code = "请输入正确的验证码";
        that.register.validate[0] = 0;
        that.register.disabled = true;
      }
    },
    registerFunc: function() {
      const that = this;
      if (that.register.disabled) {
        alert("请填写完成验证信息后，再进行下一步操作");
        return;
      }
      that.register.disabled = true;
      const user = {
        verifyCode: that.verifyCode,
        username: that.username
      };
      Auth.link({}, user).then(
        res => {
          const data = res.body;
          if (data.code === 0) {
            // 关联成功
            that.register.disabled = true;
            that.$router.replace("/");
          } else {
            that.register.disabled = false;
            alert(data.msg);
          }
        },
        res => {
          alert("服务器繁忙，请稍后再重试登录(╯﹏╰）!!!");
        }
      );
    }
  }
};
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// link.vue?b0890f1c